const mySwiper = new Swiper('.swiper-container', {
	direction: 'horizontal', // 垂直切换选项
	loop: true, // 循环模式选项
});

console.log(112121);

$('.swiper-prev').on('click', function (e) {
	mySwiper.slidePrev();
});

$('.swiper-next').on('click', function (e) {
	mySwiper.slideNext();
});

$('.js-download').click(function (e) {
	e.preventDefault();
	window.location.href = 'https://cdl.pdfxd.com/download/FFInstaller_official.exe';
	// alert('更新中...');
});
